define('../app/fukit/behavior/bind.open.tab.to.state.behavior',['require','exports','module','marionette','backbone.radio','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var Mn    = require('marionette'),
      Radio = require('backbone.radio'),
      UIKit = require('uikit/uikit');

  var BindTabToStateBehavior = Mn.Behavior.extend({
    defaults: {
      stateAttribute: 'tabName',
    },

    initialize: function() {
      Mn.Behavior.prototype.initialize.apply(this, arguments);

      if (!(this.view instanceof UIKit.Tabs)) {
        return;
      }

      this.once('before:render', function() {
        this.view.openTabIndex = this.findInitialTabIndex();
        this.setupTabListeners();
      });
    },

    setupTabListeners: function() {
      this.updateTabNameFromActiveTab();
      this.view.on(
        'change:openTabIndex',
        function(tabsView, openIndex) {
          this.updateTabNameFromActiveTab();
        },
        this
      );
    },

    updateTabNameFromActiveTab: function() {
      var menuItem = this.view.menu.at(this.view.openTabIndex);
      if (menuItem) {
        this.setTabName(menuItem.getOption('name'));
      }
    },

    setTabName: function(tabName) {
      var state = this.getState();
      if (!state) {
        return;
      }
      state.set(this.getOption('stateAttribute'), tabName || '');
    },

    findInitialTabIndex: function() {
      var state = this.getState();
      if (!state) {
        return 0;
      }
      //prettier-ignore
      var tabName = state.get(this.getOption('stateAttribute')),
          tabIndex = this.view.menu.indexOf(this.view.menu.findByName(tabName));
      return Math.max(tabIndex, 0);
    },

    getState: function() {
      return Radio.request('AppKit.controllerService', 'state');
    },
  });

  module.exports = BindTabToStateBehavior;
});

